import { Phone, DollarSign } from 'lucide-react';

/**
 * PriceModePicker — iter-218.
 *
 * Two mutually-exclusive radio-tiles:
 *   - "تحديد السعر" (fixed price) → parent shows a price input.
 *   - "تواصل لمعرفة السعر" (contact for price) → parent hides the price input;
 *     backend accepts `priceOnRequest=true` and treats `price` as 0.
 *
 * Props:
 *   value        : 'fixed' | 'onRequest'
 *   onChange     : (mode: 'fixed' | 'onRequest') => void
 *   language     : 'ar' | 'en'
 *   isDarkMode   : bool
 *   testIdPrefix : string  — used to build data-testid (e.g. "phone", "plate")
 */
export default function PriceModePicker({ value, onChange, language, isDarkMode, testIdPrefix = 'item' }) {
  const options = [
    {
      id: 'fixed',
      ar: 'تحديد السعر',
      en: 'Set a price',
      icon: DollarSign,
    },
    {
      id: 'onRequest',
      ar: 'اتصل لمعرفة السعر',
      en: 'Call for price',
      icon: Phone,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2" data-testid={`price-mode-picker-${testIdPrefix}`}>
      {options.map(opt => {
        const active = value === opt.id;
        const Icon = opt.icon;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChange(opt.id)}
            data-testid={`price-mode-${testIdPrefix}-${opt.id}`}
            className={`p-3 rounded-xl border-2 transition-all flex items-center gap-2 ${
              active
                ? 'bg-[#1E9BD9]/15 border-[#1E9BD9] text-[#1E9BD9]'
                : (isDarkMode
                    ? 'bg-white/5 border-white/10 text-gray-300 hover:border-white/20'
                    : 'bg-white border-gray-200 text-gray-700 hover:border-gray-300')
            }`}
          >
            <Icon className={`h-4 w-4 flex-shrink-0 ${active ? 'text-[#1E9BD9]' : ''}`} />
            <span className="text-xs font-semibold text-start leading-tight">
              {language === 'ar' ? opt.ar : opt.en}
            </span>
          </button>
        );
      })}
    </div>
  );
}
